module.exports = __webpack_public_path__ + "img/juan.c47ed3d4.png";